import { IUserOptionsConfig } from "../types/userOptions";

/**
 * Безопасное получение конфигурации из localStorage
 */
export const getUserConfigFromStorage = (): Partial<IUserOptionsConfig> | null => {
  try {
    const userConfig = localStorage.getItem("userConfig");
    if (!userConfig) return null;

    const parsed = JSON.parse(userConfig);
    // Проверяем, что конфигурация имеет нужную структуру
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
    return null;
  } catch (error) {
    console.error("Ошибка при парсинге userConfig из localStorage:", error);
    return null;
  }
};

/**
 * Сохранение конфигурации в localStorage
 * Сохраняет полное состояние из Redux store
 */
export const saveUserConfigToStorage = (config: Partial<IUserOptionsConfig>): void => {
  try {
    localStorage.setItem("userConfig", JSON.stringify(config));
  } catch (error) {
    console.error("Ошибка при сохранении userConfig в localStorage:", error);
  }
};

/**
 * Получение состояния открыто/закрыто сайдбара из localStorage
 */
export const getSidebarOpenFromStorage = (): boolean => {
  try {
    const value = localStorage.getItem("isSidebarOpen");
    if (value === null) return true;
    return value === "true";
  } catch (error) {
    console.error("Ошибка при чтении isSidebarOpen из localStorage:", error);
    return true;
  }
};

/**
 * Сохранение состояния открыто/закрыто сайдбара в localStorage
 */
export const saveSidebarOpenToStorage = (isOpen: boolean): void => {
  try {
    localStorage.setItem("isSidebarOpen", String(isOpen));
  } catch (error) {
    console.error("Ошибка при сохранении isSidebarOpen в localStorage:", error);
  }
};

/**
 * Подготовка конфигурации для отправки на бэк
 * Исключает локальные настройки (isOpen), которые не должны отправляться
 */
export const prepareConfigForBackend = (config: Partial<IUserOptionsConfig>): Partial<IUserOptionsConfig> => {
  const configToSend = { ...config };

  // Исключаем isOpen из SideBarConfig - это локальная настройка
  if (configToSend.SideBarConfig) {
    const { isOpen, ...sideBarConfigWithoutIsOpen } = configToSend.SideBarConfig;
    configToSend.SideBarConfig = {
      ...sideBarConfigWithoutIsOpen,
    };
  }

  return configToSend;
};
